import _t from "../../../languages/translate";
import { checkDate } from "../../helper/helperMethods";

export const convDate = (date, withZero) => {
  if (checkDate(date)) {
    if (withZero) {
      return new Date(date.startOf("day"));
    } else {
      return new Date(date);
    }
  } else {
    return undefined;
  }
};

export const _titleByType = (t) => {
  switch (t) {
    case 1:
      return _t("strAbsence");
    case 2:
      return _t("strOneMoreDay");
    case 3:
      return _t("strDelay");
    case 4:
      return _t("strExtraTime");
    case 5:
      return _t("strRequestMission");
    case 6:
      return _t("strLeaveRequest");
    case 7:
      return _t("strAdvanceRequest");
    case 8:
      return _t("strAdditions");
    case 9:
      return _t("strDeductions");
    default:
      return "";
  }
};

export const _options = [
  {
    label: _t("strIn"),
    value: 0,
  },
  {
    label: _t("strOut"),
    value: 1,
  },
];

export const _showByType = (type) => {
  let obj = {
    showApplyDate: true,
    showTimeType: true,
    showErrandVacationId: true,
    showApplyFromDate: true,
    showApplyToDate: true,
    showValue: true,
    showSalaryAdvTypeId: true,
    showAddDiscTypeId: true,
  };

  switch (type) {
    case 1:
      obj.showTimeType = false;
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      obj.showValue = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 2:
      obj.showTimeType = false;
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      obj.showValue = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 3:
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      obj.showValue = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 4:
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      obj.showValue = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 5:
      obj.showApplyDate = false;
      obj.showTimeType = false;
      obj.showValue = false;
      obj.showSalaryAdvTypeId = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 6:
      obj.showApplyDate = false;
      obj.showTimeType = false;
      obj.showValue = false;
      obj.showSalaryAdvTypeId = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 7:
      obj.showTimeType = false;
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showAddDiscTypeId = false;
      return obj;
    case 8:
      obj.showTimeType = false;
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      return obj;
    case 9:
      obj.showTimeType = false;
      obj.showErrandVacationId = false;
      obj.showApplyFromDate = false;
      obj.showApplyToDate = false;
      obj.showSalaryAdvTypeId = false;
      return obj;
    default:
      return obj;
  }
};
